const initState = {
  offices: [],
  successFetching: false,
  errorFetching: false,
};

export default initState;
